<p-toast></p-toast>
<div class="grid">
    <div class="col-12">
        <div *ngIf="!intimationAction" class="card">
            <div class="card dashboardTable">
                <p-table #farmerPondIntimationTable [value]="farmerPondIntimationData"
                    dataKey="AppID" [rows]="10"
                    [paginator]="true"
                    [globalFilterFields]="['AppID','DtIntimated','FirstIntimation','SecondIntimation','ThirdIntimation']"
                    responsiveLayout="scroll" [rowHover]="true"
                    currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                    [showCurrentPageReport]="true" [loading]="loading">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items-center justify-content-between">
                            <h5 class="m-0">{{'FARMER_POND_INTIMATION'| translate}}</h5>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="farmerPondIntimationTable.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="{{'SEARCH'| translate}}" />
                            </span>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="AppID">{{'APP_ID'| translate}}
                                <p-columnFilter type="text" field="AppID" display="menu"></p-columnFilter>
                                <p-sortIcon field="AppID"></p-sortIcon>
                            </th>
                            <th pSortableColumn="DtIntimated">{{'DT_INTIMATED'| translate}}
                                <p-columnFilter type="text" field="DtIntimated" display="menu"></p-columnFilter>
                                <p-sortIcon field="DtIntimated"></p-sortIcon>
                            </th>
                            <th pSortableColumn="FirstIntimation">{{'FIRST_INTIMATION'| translate}}
                                <p-columnFilter type="text" field="FirstIntimation" display="menu"></p-columnFilter>
                                <p-sortIcon field="FirstIntimation"></p-sortIcon>
                            </th>
                            <th pSortableColumn="SecondIntimation">{{'SECOND_INTIMATION'| translate}}
                                <p-columnFilter type="text" field="SecondIntimation" display="menu"></p-columnFilter>
                                <p-sortIcon field="SecondIntimation"></p-sortIcon>
                            </th>
                            <th pSortableColumn="ThirdIntimation">{{'THIRD_INTIMATION'| translate}}
                                <p-columnFilter type="text" field="ThirdIntimation" display="menu"></p-columnFilter>
                                <p-sortIcon field="ThirdIntimation"></p-sortIcon>
                            </th>
                            <th></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product>
                        <tr>
                            <td>{{product.AppID}}</td>
                            <td>{{product.DtIntimated | date:"medium"}}</td>
                            <td>{{product.FirstIntimation}}</td>
                            <td>{{product.SecondIntimation}}</td>
                            <td>{{product.ThirdIntimation}}</td>
                            <td>
                                <!-- <button pButton pRipple type="button" pTooltip="Edit Intimation" icon="pi pi-pencil"
                                class="p-button-rounded p-button-text" (click)="editIntimation(product)"></button> -->
                                <button  pButton pRipple type="button" label="{{'INTIMATE'| translate}}" class="p-button-rounded p-button-info"
                                    (click)="onIntimate(product)"></button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            {{'IN_TOTAL_THERE_ARE'| translate}} {{farmerPondIntimationData ? farmerPondIntimationData.length : 0 }} {{'FARMER_POND_INTIMATION_ADDED'| translate}}.
                        </div>
                        <!-- <button pButton type="button" label="View Challan" class="p-button-primary"
                            (click)="printChallan()"></button> -->
                    </ng-template>
                </p-table>
            </div>
        </div>


        <div *ngIf="intimationAction" class="card">
            <div class="card surface-section">
                <div class="mb-3" [style]="{'font-size': '1.2rem', 'weight': 'bold'}"><b>{{'ENTER_POND_PROGRESS_STAGE'| translate}}</b></div>

                <div *ngIf="pondIntimationObject">
                    <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                        <div class="field md:col-6 col-12" [style]="{'font-size': '1rem'}">
                            <b><label>{{'APPLICATION_NUMBER'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">
                                {{pondIntimationObject.AppID}}</label></label></b>
                        </div>
                    </div>
                    <ul class="list-none p-0 m-0">
                        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                            <div class="text-900 w-6 md:w-2 font-medium">{{'STAGE1'| translate}}</div>
                            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{'WHETHER_COMPLETION_OF_EARTH'| translate}}
                            </div>
                            <div class="w-6 md:w-2">
                                <!-- <button pButton pRipple label="Edit" icon="pi pi-pencil" class="p-button-text"></button> -->
                                <p-selectButton [options]="stateOptions" [(ngModel)]="firstIntimation" optionLabel="label" optionValue="value" [disabled]="this.pondIntimationObject?.IsEditableStage1 == 0"></p-selectButton>
                            </div>
                        </li>
                        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                            <div class="text-900 w-6 md:w-2 font-medium">{{'STAGE2'| translate}}</div>
                            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{'WHETHER_COMPLETION_OF_WORK'| translate}}
                                </div>
                            <div class="w-6 md:w-2">
                                <!-- <button pButton pRipple label="Edit" icon="pi pi-pencil" class="p-button-text"></button> -->
                                <p-selectButton [options]="stateOptions" [(ngModel)]="secondIntimation" optionLabel="label" optionValue="value" [disabled]="this.pondIntimationObject?.IsEditableStage2 == 0"></p-selectButton>
                            </div>
                        </li>
                        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                            <div class="text-900 w-6 md:w-2 font-medium">{{'STAGE3'| translate}}</div>
                            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{'THIRD_INITMATION'| translate}}</div>
                            <div class="w-6 md:w-2">
                                <!-- <button pButton pRipple label="Edit" icon="pi pi-pencil" class="p-button-text"></button> -->
                                <p-selectButton [options]="stateOptions" [(ngModel)]="thirdIntimation" optionLabel="label" optionValue="value" [disabled]="true"></p-selectButton>
                            </div>
                        </li>
                    </ul>
                    <div class="font-medium text-2xl text-900 my-5 flex justify-content-around">
                        <button pButton pRipple type="button" label="{{'SUBMIT_YOUR_ANSWER'| translate}}" class="p-button-success" (click)="onFormSubmit()"></button>
                        <button pButton pRipple type="button" label="{{'BACK'| translate}}" class="p-button-secondary" (click)="onBack()"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>